// src/constants/formSpecs.js

export const FIELD_TYPES = {
  TEXT: 'text',
  NUMBER: 'number',
  DROPDOWN: 'dropdown',
  MULTI_SELECT: 'multiSelect',
  DATE: 'date',
  TOGGLE: 'toggle',
  TEXTAREA: 'textarea'
};

// 1. COMMON FIELDS (Used in every single ad regardless of category)
export const COMMON_FIELDS = [
  { name: 'title', label: 'Ad Title', type: FIELD_TYPES.TEXT, required: true, maxLength: 70, hint: 'e.g. iPhone 13 Pro Max for sale' },
  { name: 'description', label: 'Description', type: FIELD_TYPES.TEXTAREA, required: true, maxLength: 4000, hint: 'Describe what you are selling...' },
  { name: 'price', label: 'Price', type: FIELD_TYPES.NUMBER, required: true, prefix: '₹' },
];

const BASE_ELECTRONICS = [
  { name: 'brand', label: 'Brand', type: FIELD_TYPES.TEXT, required: true },
  { name: 'model', label: 'Model', type: FIELD_TYPES.TEXT, required: false },
  { name: 'condition', label: 'Condition', type: FIELD_TYPES.DROPDOWN, options: ['Brand New', 'Like New', 'Good', 'Fair', 'Poor'], required: true },
  { name: 'warranty', label: 'Warranty Available', type: FIELD_TYPES.DROPDOWN, options: ['Yes', 'No'], required: false },
];

// 2. CATEGORY SPECIFIC FIELDS
// Keys (c1, c2, c3, etc.) match your Flutter Category IDs exactly.
export const CATEGORY_FORM_SPECS = {
  'c1': [ // Cars
    { name: 'brand', label: 'Brand', type: FIELD_TYPES.DROPDOWN, options: ['Maruti Suzuki', 'Hyundai', 'Tata', 'Mahindra', 'Honda', 'Toyota', 'Kia', 'Volkswagen', 'Renault', 'Nissan', 'MG', 'Skoda', 'Mercedes-Benz', 'BMW', 'Audi', 'Jeep', 'Other'], required: true },
    { name: 'model', label: 'Model', type: FIELD_TYPES.TEXT, required: true },
    { name: 'year', label: 'Year', type: FIELD_TYPES.NUMBER, required: true, min: 1990, max: 2026 },
    { name: 'fuelType', label: 'Fuel Type', type: FIELD_TYPES.DROPDOWN, options: ['Petrol', 'Diesel', 'CNG', 'Electric', 'Hybrid'], required: true },
    { name: 'transmission', label: 'Transmission', type: FIELD_TYPES.DROPDOWN, options: ['Manual', 'Automatic'], required: true },
    { name: 'kmsDriven', label: 'KMs Driven', type: FIELD_TYPES.NUMBER, required: true, suffix: 'km' },
    { name: 'owners', label: 'No. of Owners', type: FIELD_TYPES.DROPDOWN, options: ['1st', '2nd', '3rd', '4th', '4+'], required: true },
    { name: 'bodyType', label: 'Body Type', type: FIELD_TYPES.DROPDOWN, options: ['Sedan', 'SUV', 'Hatchback', 'MUV', 'Coupe', 'Convertible', 'Pickup', 'Van'], required: false },
    { name: 'condition', label: 'Condition', type: FIELD_TYPES.DROPDOWN, options: ['Excellent', 'Good', 'Fair', 'Needs Repair'], required: true },
  ],

  'c2': [ // Bikes
    { name: 'brand', label: 'Brand', type: FIELD_TYPES.TEXT, required: true },
    { name: 'model', label: 'Model', type: FIELD_TYPES.TEXT, required: true },
    { name: 'year', label: 'Year', type: FIELD_TYPES.NUMBER, required: true },
    { name: 'kmsDriven', label: 'KMs Driven', type: FIELD_TYPES.NUMBER, required: true },
    { name: 'owners', label: 'No. of Owners', type: FIELD_TYPES.DROPDOWN, options: ['1st', '2nd', '3rd', '4th+'], required: true },
    { name: 'condition', label: 'Condition', type: FIELD_TYPES.DROPDOWN, options: ['Excellent', 'Good', 'Fair', 'Needs Repair'], required: true },
  ],

  'c3': [ // Properties
    { name: 'propertyType', label: 'Property Type', type: FIELD_TYPES.DROPDOWN, options: ['Apartment', 'House / Villa', 'Plot', 'Shop / Office', 'PG / Guest House', 'Farmhouse'], required: true },
    { name: 'transactionType', label: 'Listing For', type: FIELD_TYPES.DROPDOWN, options: ['Sale', 'Rent'], required: true },
    { name: 'bhk', label: 'BHK', type: FIELD_TYPES.DROPDOWN, options: ['Studio', '1 BHK', '2 BHK', '3 BHK', '4 BHK', '5+ BHK'], required: false },
    { name: 'bathrooms', label: 'Bathrooms', type: FIELD_TYPES.NUMBER, required: false },
    { name: 'furnishing', label: 'Furnishing', type: FIELD_TYPES.DROPDOWN, options: ['Fully Furnished', 'Semi-Furnished', 'Unfurnished'], required: false },
    { name: 'builtUpArea', label: 'Built-up Area (sq.ft)', type: FIELD_TYPES.NUMBER, required: false },
    { name: 'carpetArea', label: 'Carpet Area (sq.ft)', type: FIELD_TYPES.NUMBER, required: false },
    { name: 'parking', label: 'Parking', type: FIELD_TYPES.DROPDOWN, options: ['Available', 'Not Available'], required: false },
    { name: 'buildingAge', label: 'Building Age', type: FIELD_TYPES.DROPDOWN, options: ['Under Construction', '0-1 years', '1-5 years', '5-10 years', '10+ years'], required: false },
    { name: 'floors', label: 'Total Floors', type: FIELD_TYPES.TEXT, required: false },
    { name: 'amenities', label: 'Amenities', type: FIELD_TYPES.MULTI_SELECT, options: ['Parking', 'Gym', 'Swimming Pool', 'Lift', 'Garden', 'Security', 'Balcony'], required: false },
  ],

  // Electronics & Appliances (Includes Laptops, Fridges, ACs)
  // 'c4': [ 
  //   { name: 'brand', label: 'Brand', type: FIELD_TYPES.TEXT, required: true },
  //   { name: 'model', label: 'Model', type: FIELD_TYPES.TEXT, required: false },
  //   { name: 'condition', label: 'Condition', type: FIELD_TYPES.DROPDOWN, options: ['Brand New', 'Like New', 'Good', 'Fair', 'Poor'], required: true },
  //   { name: 'warranty', label: 'Warranty', type: FIELD_TYPES.DROPDOWN, options: ['Yes', 'No'], required: false },
  //   // Laptop Specific (Usually filled by AI)
  //   { name: 'processor', label: 'Processor', type: FIELD_TYPES.TEXT, required: false },
  //   { name: 'ram', label: 'RAM', type: FIELD_TYPES.TEXT, required: false },
  //   { name: 'storage', label: 'Storage', type: FIELD_TYPES.TEXT, required: false },
  //   { name: 'screenSize', label: 'Screen Size', type: FIELD_TYPES.TEXT, required: false },
  //   // Appliance Specific
  //   { name: 'fridgeType', label: 'Fridge Type', type: FIELD_TYPES.TEXT, required: false },
  //   { name: 'capacityLiters', label: 'Capacity (Liters)', type: FIELD_TYPES.NUMBER, required: false },
  //   { name: 'acType', label: 'AC Type', type: FIELD_TYPES.TEXT, required: false },
  //   { name: 'starRating', label: 'Star Rating', type: FIELD_TYPES.DROPDOWN, options: ['1 Star', '2 Star', '3 Star', '4 Star', '5 Star'], required: false },
  // ],

  'c4': [...BASE_ELECTRONICS], // Default for Kitchen Appliances, etc.

  'c5': [ // Mobiles
    { name: 'brand', label: 'Brand', type: FIELD_TYPES.TEXT, required: true },
    { name: 'model', label: 'Model', type: FIELD_TYPES.TEXT, required: true },
    { name: 'storage', label: 'Storage', type: FIELD_TYPES.DROPDOWN, options: ['16GB', '32GB', '64GB', '128GB', '256GB', '512GB', '1TB'], required: false },
    { name: 'ram', label: 'RAM', type: FIELD_TYPES.DROPDOWN, options: ['2GB', '3GB', '4GB', '6GB', '8GB', '12GB', '16GB'], required: false },
    { name: 'condition', label: 'Condition', type: FIELD_TYPES.DROPDOWN, options: ['Brand New', 'Like New', 'Good', 'Fair', 'Poor'], required: true },
    { name: 'warranty', label: 'Warranty', type: FIELD_TYPES.DROPDOWN, options: ['Under Warranty', 'No Warranty'], required: false },
    { name: 'accessories', label: 'Accessories', type: FIELD_TYPES.MULTI_SELECT, options: ['Box', 'Charger', 'Earphones', 'Bill', 'Case'], required: false },
  ],


  // --- SUB-CATEGORY OVERRIDES ---
  'Computers & Laptops': [
    ...BASE_ELECTRONICS,
    { name: 'processor', label: 'Processor', type: FIELD_TYPES.TEXT, required: true },
    { name: 'ram', label: 'RAM', type: FIELD_TYPES.TEXT, required: true },
    { name: 'storage', label: 'Storage', type: FIELD_TYPES.TEXT, required: true },
    { name: 'screenSize', label: 'Screen Size', type: FIELD_TYPES.TEXT, required: false },
  ],
  'Fridges': [
    ...BASE_ELECTRONICS,
    { name: 'fridgeType', label: 'Fridge Type', type: FIELD_TYPES.DROPDOWN, options: ['Single Door', 'Double Door', 'Side-by-Side', 'French Door'], required: true },
    { name: 'capacityLiters', label: 'Capacity (Liters)', type: FIELD_TYPES.NUMBER, required: true },
    { name: 'starRating', label: 'Energy Rating', type: FIELD_TYPES.DROPDOWN, options: ['1 Star', '2 Star', '3 Star', '4 Star', '5 Star'], required: false },
  ],
  'ACs': [
    ...BASE_ELECTRONICS,
    { name: 'acType', label: 'AC Type', type: FIELD_TYPES.DROPDOWN, options: ['Split AC', 'Window AC', 'Portable AC'], required: true },
    { name: 'capacityTons', label: 'Capacity (Tons)', type: FIELD_TYPES.DROPDOWN, options: ['0.8', '1.0', '1.5', '2.0'], required: true },
    { name: 'starRating', label: 'Energy Rating', type: FIELD_TYPES.DROPDOWN, options: ['1 Star', '2 Star', '3 Star', '4 Star', '5 Star'], required: false },
  ],

  'c7': [ // Furniture
    { name: 'material', label: 'Material', type: FIELD_TYPES.TEXT, required: false },
    { name: 'age', label: 'Age of Item', type: FIELD_TYPES.TEXT, required: false },
    { name: 'condition', label: 'Condition', type: FIELD_TYPES.DROPDOWN, options: ['Excellent', 'Good', 'Fair'], required: true },
  ],

  'c8': [ // Books, Sports & Hobbies
    { name: 'condition', label: 'Condition', type: FIELD_TYPES.DROPDOWN, options: ['Brand New', 'Gently Used', 'Fair'], required: true },
  ],

  'c9': [ // Fashion
    { name: 'material', label: 'Material', type: FIELD_TYPES.TEXT, required: false },
    { name: 'condition', label: 'Condition', type: FIELD_TYPES.DROPDOWN, options: ['New with Tags', 'Like New', 'Gently Used'], required: true },
  ],

  'c10': [ // Services
    { name: 'experience', label: 'Experience (Years)', type: FIELD_TYPES.NUMBER, required: false },
    { name: 'serviceArea', label: 'Service Area', type: FIELD_TYPES.TEXT, required: false },
    { name: 'availability', label: 'Availability', type: FIELD_TYPES.TEXT, required: false },
  ]
};